export const RETRIEVED_NOTIFICATIONS = 'RETRIEVED_NOTIFICATIONS'